module.exports = __webpack_public_path__ + "img/info_10.8cd7030c.jpeg";